// Set through the CSSOM: writing a style attribute is blocked by the Content-Security-Policy.
export default function(element, display = "inherit") {
  element.style.setProperty("display", display);
}
